import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import userManager from '../services/oidc';

const CallbackPage: React.FC = () => {
  const history = useHistory();

  console.log('=== CALLBACK PAGE COMPONENT RENDERED ===');
  console.log('CallbackPage is now active');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('=== CALLBACK PAGE LOADED ===');
        console.log('Current URL:', window.location.href);
        console.log('URL search params:', window.location.search);
        console.log('Processing OIDC callback...');
        
        const user = await userManager.signinRedirectCallback();
        console.log('Callback successful, user:', user);
        console.log('Dispatching authentication update event...');
        
        // Dispatch event and wait a bit for React state to update
        window.dispatchEvent(new CustomEvent('oidc-auth-update'));
        
        // Wait a short time to ensure OIDCProvider state updates before navigation
        // This is especially important for MFA flows where token might not be immediately available
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Double-check that user data is in localStorage before navigating
        const userStr = localStorage.getItem("oidc.user");
        if (!userStr) {
          console.warn('User data not found in localStorage after callback, waiting a bit longer...');
          await new Promise(resolve => setTimeout(resolve, 200));
        }
        
        console.log('Navigating to /...');
        history.push('/');
      } catch (error) {
        console.error('Callback failed:', error);
        console.log('Navigating to / with error...');
        history.push('/?error=' + encodeURIComponent((error as Error).message));
      }
    };

    console.log('CallbackPage useEffect triggered');
    handleCallback();
  }, [history]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3">Processing authentication...</p>
    </div>
  );
};

export default CallbackPage;
